module.exports = __webpack_public_path__ + "img/ia.51ecbe01.svg";